import Component from "../abstracts/Component";

export default class TrackingComponent extends Component {

  get SELECTORS() {
    return {
      dataTracking: '[data-tracking-action]:not(form)',
      cartPage: '.t-cart',
      O2OCCSearchInput: '#mm_sl-search-input',
      trackingPayload: '[data-tracking-payload]',
    }
  }

  // retrieve object/sub-object identified by [data-tracking-payload] attribute and parse them with .data() method
  getTrackingPayloadData(el, list) {
    let elements;

    if (list == true) {
      elements = $(el).find(this.SELECTORS.trackingPayload);
    } else {
      elements = $(el).closest(this.SELECTORS.dataTracking).find(this.SELECTORS.trackingPayload);
    }

    let products = [];
    elements.each(function () {
      products.push($(this).data());
    });
    return products;
  }

  constructor() {
    super();
    this.actions = {
      loadMore: (payload) => {
        if (payload != null) {
          let products = this.getTrackingPayloadData($.parseHTML(payload), true);
          if (typeof products === 'undefined' || products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          try {
            this.log("tracking loadMore event with " + products.length + " more products");
            window.listViewMore(products);
          } catch(e) {
            this.warn("listViewMore tracking function not available");
          }
        }
      },
      productView: (params, el) => {
        try {
          if (el) {
            let products = this.getTrackingPayloadData(el, false);
            if (typeof products === 'undefined' || products.length == 0) {
              this.log("no products loaded");
              return;
            }
            // TODO: add other templates..
            let product = products[0];
            let template = product.template;
            let similarProducts = document.getElementById("similarProducts");
            if (typeof product.template !== 'undefined') {
              if (template === 'product-page') {
                // TODO: add other carousel types..
                if (this.isParent("#products-crosselling", el) || this.isParent("#products-crosselling_night", el)) {
                  try {
                    let elem = this.getWearItWith();
                    let elemName = elem.getAttribute('data-name');
                    this.log('tracking listCarouselClick event for product: ' + product.id);
                    window.listCarouselClick(elemName, product);
                  } catch (e) {
                    this.warn('listCarouselClick tracking function not available');
                  }
                } else if (this.mobileCarouselTracking(el) && this.getWearItWith() != null) {
                  try {
                    let elem = this.getWearItWith();
                    let elemName = elem.getAttribute('data-name');
                    this.log('tracking listCarouselClick event for product: ' + product.id);
                    window.listCarouselClick(elemName, product);
                  } catch (e) {
                    this.warn('listCarouselClick tracking function not available');
                  }
                } else if (this.isParent("#products-salesforce_reccomandations", el)) {
                  this.log("tracking listCarouselClick event for product: " + product.id);
                  window.listCarouselClick('recommendation-engine-container-SF', product);
                } else {
                  try {
                    this.log("tracking listProdClick event for product: " + product.id);
                    window.listProdClick(product);
                  } catch (e) {
                    this.warn('listProdClick tracking function not available');
                  }
                }
              } else if (template === "na:c-google-recommendation-engine") {
                try {
                  this.log("tracking listCarouselClick event for product: " + product.id);
                  let servingConfigId = document.getElementById("servingConfigId");
                  let googleModel = '';
                  let carouselName = '';
                  if (typeof similarProducts !== 'undefined' && similarProducts !== null && similarProducts.value) {
                    carouselName = 'google-recommendation-engine-container-SOLR';
                  } else {
                    if (typeof servingConfigId !== 'undefined' && servingConfigId !== null && servingConfigId !== '' && servingConfigId.value !== '') {
                      googleModel = '_' + servingConfigId.value;
                    }
                    let page = '';
                    let dataTemplate = document.querySelector('body').getAttribute('data-template');
                    if (typeof dataTemplate !== 'undefined' && dataTemplate !== null) {
                      page = '-' + dataTemplate;
                    }
                    carouselName = "google-recommendation-engine-container" + page + googleModel;
                  }
                  window.listCarouselClick(carouselName, product);
                } catch (e) {
                  this.warn("listCarouselClick tracking function not available");
                }
              } else if (template === "na:c-recommendation-engine") {
                try {
                  this.log("tracking listCarouselClick event for product: " + product.id);
                  let carouselName = '';
                  if (typeof similarProducts !== 'undefined' && similarProducts !== null && similarProducts.value) {
                    carouselName = 'recommendation-engine-container-SOLR';
                  } else {
                    carouselName = 'recommendation-engine-container-SF';
                  }
                  window.listCarouselClick(carouselName, product);
                } catch (e) {
                  this.warn("listCarouselClick tracking function not available");
                }
              } else {
                try {
                  this.log("tracking listProdClick event for product: " + product.id);
                  window.listProdClick(product);
                } catch (e) {
                  this.warn('listProdClick tracking function not available');
                }
              }
            }
          }
        } catch (e) {
          this.warn('carousel click tracking not available');
        }
      },
      searchView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (typeof products === 'undefined' || products.length == 0) {
            console.log('no products loaded');
            return;
          }
          let product = products[0];
          try {
            console.log("tracking searchProdClick event for product: " + product.id);
            window.searchProdClick(product);
          } catch (e) {
            console.warn("searchProdClick tracking function not available");
          }
          if (product.isAlgoliaEnabled) {
            this.actions.algolia(params);
          }
        }
      },
      miniPreview: (params) => {
        var productCodeList = params.productCodeList;
        if (typeof productCodeList === 'undefined') {
          this.warn('no productCodeList found');
          return;
        }
        try {
          const codeListString = App.Components.Tracking.getListString(productCodeList);
          this.log('code list: ' + codeListString);
          mm_mini_preview(codeListString);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      wishlist: (params) => {
        var productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('add to wishlist with code: ' + productCode);
          utag.wishlist_add(';' + productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      addToCart: (params) => {
        var productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('add to cart with code: ' + productCode);
          utag.cart_add(';' + productCode);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      login: (params) => {
        try {
          utag.link({
            event_name: "login",
            login_type: params.loginType
          });
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      removeProduct: (params) => {
        var productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('remove product from cart with code: ' + productCode);
          var data = new Object();
          data['event_name'] = 'remove_from_cart';
          data['store_country'] = params.storeCountry,
          data['user_type'] = params.userType,
          data['page_type'] = params.pageType,
          data['page_name'] = params.pageName,
          data['sf_id'] = params.salesforceId,
          data['value'] = params.value,
          utag.link(data)
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      removeQuantity: (params) => {
        var productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          if (!params.disabled) {
            this.log('remove quantity from cart with code: ' + productCode);
            mm_remove_qt(';' + productCode);
          }
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      addQuantity: (params) => {
        var productCode = params.productCode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          if (!params.disabled) {
            this.log('add quantity to cart with code: ' + productCode);
            mm_add_qt(';' + productCode);
          }
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      newsletter: (params) => {
        const pos = params.pos;
        const type = params.type ? "-" + params.type : '';
        try {
          this.log('NL-Subscription,   type: ' + type + ' pos: ' + pos);
          ga('send', 'event', 'NL', 'NL-Subscription' + type, pos);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      formisimo: (params) => {
        console.debug("formisimo: ", params);
        if (typeof window.TealiumConversionForm == "function") {
          console.debug("TealiumConversionForm: ", params);
          window.TealiumConversionForm(params.formId, params.result);
        } else {
          //keep data in a global var
          window.Tealium.trackingData = {
            formId: params.formId,
            formResult: params.result
          }
        }
      },
      sizeSelection: (params) => {
        var productCode = params.code;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('sizeSelection with code: ' + productCode);
          utag.size_selection(';' + productCode);
        } catch(e) {
          this.warn('Utag tracking is not available');
        }
      },
      O2OCCSelect: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log('tracking 020 CC selected event');
          utag.click_collect('click');
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSearch: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let o2oCCSearchInput = $(this.SELECTORS.O2OCCSearchInput).val();
        try {
          this.log('tracking 020 CC store search event: ' + o2oCCSearchInput);
          utag.click_collect(o2oCCSearchInput);
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCLocalize: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log('tracking 020 CC localize event');
          utag.click_collect('localizza');
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSelectStore: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let storeName = params.storeName;
        if (typeof storeName === 'undefined') {
          this.warn('no storeName found');
          return;
        }
        try {
          this.log('tracking 020 CC store select event: ' + storeName);
          utag.click_collect("store:" + storeName);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      algolia: (params) => {
        console.log('algolia ' + params);
        params.position = params.position + 1; //Algolia è 1-based e non 0-based
        console.debug("Algolia " + params.position + ' ' + params.productId);
        $.ajax({
          url: 'action/ajax/algolia-notification',
          type: 'post',
          cache: 'false',
          data: {
            positionId: params.position,
          },
          success: function (data) {
            console.log('algolia success')
          },
          error: function (errorObj, textStatus, errorThrown) {
            console.warn('algolia error')
          }
        });
        // call product view on utag
        this.actions.productView({params});
      },
      filterTracking: (params) => {
        let facetCode = params.dataset.facetCode;
        let facetName = params.dataset.code;
        if(facetCode && facetName) {
          console.log("Triggering filter " + facetCode + ": " + facetName);

          try {
            console.log("tracking link event: " + facetName);
            utag.link({
              filter: facetCode + ":" + facetName,
              event_name: "filter_usage"
            });
          } catch(e) {
            console.warn("Utag tracking not available");
          }
        }
      },
      sortTracking: (sortName, sortMethod, sortType) => {
        let sortCode = "orderBy";
        if(sortName) {
          console.log("triggering filter " + sortCode + ": " + sortName);

          try {
            console.log("tracking link event: " + sortName);
            utag.link({
              filter: sortCode + ":" + sortName,
              sorting_method: sortMethod,
              sorting_type: sortType,
              event_name: "filter_usage"
            });
          } catch(e) {
            console.warn("utag tracking not available");
          }
        }
      },
    shortcutCategoryView: (params) => {
      try {
        this.log('Tracking shortcut category click: ' + params.shortcutLabel);
        var data = new Object();
        data['event_name'] = 'select_content';
        data['event_location'] = params.shortcutNumber// es. shortcut-micro_1, shortcut-macro_4 …
        data['event_detail'] = params.shortcutLabel// es. our selection, clothing, pantaloni, abiti, …
        data['content_type'] = params.shortcutType// es. shortcut-micro, shortcut-macro…
        utag.link(data)
      } catch(e) {
        this.warn("Utag tracking not available");
      }
    },
    startChat: () => {
      try {
        this.log("tracking startChat event");
        utag.link({
          event_name: "chat_start"
        });
      }
      catch (e) {
        this.warn("Utag tracking not available");
      }
    },
    deleteChat: () => {
      try {
        this.log("tracking deleteChat event");
        utag.link({
          event_name: "chat_delete"
        });
      }
      catch (e) {
        this.warn("Utag tracking not available");
      }
    },
    addCartGiftCard: (params) => {
      try {
        this.log("tracking addCartGiftCard event");
        utag.link({
          event_category: "gift card",
          event_action: "add to cart",
          event_label: "giftcart " + params,
          event_name: "giftcart_add_to_cart"
        });
      }
      catch (e) {
        this.warn("Utag tracking not available");
      }
    },
    newsletterSubscribe: (params) => {
      try {
        this.log("tracking newsletterSubscribe event");
        let position = params.trackingPosition;
        utag.link({
          event_name: "newsletter_subscribe",
          event_location: position
        });
      }
      catch (e) {
        this.warn("Utag tracking not available");
      }
    },
    whatsappStart: () => {
      try {
        this.log("tracking whatsappStart event");
        utag.link({
          event_name: "whatsapp_start"
        });
      }
      catch (e) {
        this.warn("Utag tracking not available");
      }
    },
    register: (params) => {
      if(params && params[0]) {
        var data = params[0];
        this.log("Triggering register tracking");
        try {
          this.log('tracking register event: ' + data);
          utag.link({
            event_name: data.eventName,
            page_name: data.pageName,
            page_type: data.pageType,
            login_type: data.userType,
            store_country: data.storeCountry,
            event_method: data.eventMethod
          });
        } catch(e) {
          this.warn("Utag tracking not available");
        }
      }
    },
      //    other action found but not necessary:
      //    mm_nl_request(),mm_notify(),utag.size_selection(),mm_filter();
    }
  }

  isCartPage() {
    let element = $(this.SELECTORS.cartPage);
    if (element.length > 0) {
      return true;
    }
    return false;
  }

  isLogged() {
    const locationPath = window.location + "";
    return locationPath.split("/")[3].split("?")[1] === "login=success"
  }

  getListString(codeList) {

    let listString = ";";

    $.each(codeList, function (index, value) {
      listString += value + ",;";
    });

    listString = listString.substr(0, listString.lastIndexOf(","));
    return listString;
  }

  isParent(parentSelector, childEl) {
    if(childEl != null && typeof childEl !== 'undefined' && parentSelector!=null) {
      try {
        let parent = document.querySelector(parentSelector);
        if (parent != null) {
          if (parent.contains(childEl)) {
            return true;
          }
        }
      } catch (e) {
        return false;
      }
    }
    return false;
  }

  //gets last element with class suggestions__input and does the check on el (productView)
  mobileCarouselTracking(el) {
    try {
      let parent = document.getElementsByClassName("suggestions__input")[document.getElementsByClassName("suggestions__input").length - 1];
      if (parent != null) {
        if (parent.contains(el)) {
          return true;
        }
      }
    } catch(e) {
      return false;
    }
    return false;
  }

  getWearItWith() {
    let elem = document.querySelector("#products-crosselling");
    if (typeof elem === 'undefined' || elem == null) {
      elem = document.querySelector("#products-crosselling_night");
      if (typeof elem === 'undefined' || elem == null) {
        return null;
      }
    }
    return elem;
  }

  isLookOnload() {
    try {
      let carousel = document.querySelectorAll('.carousel');
      let similarProducts = document.getElementById("similarProducts");
      let servingConfigId = '';
      let page = '';
      let googleModel = '';
      if (typeof (carousel) !== 'undefined' && carousel !== null && carousel.length > 0) {
        let elem = document.querySelector("#google-recommendation-engine-container");
        if (elem == null) {
          this.log('No "wear it with" carousel found');
          elem = this.getWearItWith();
          if (typeof elem === 'undefined' || elem == null) {
            this.log('No "Google recommendation" carousel found');
            elem = document.querySelector("#recommendation-engine-container");
            if (typeof elem === 'undefined' || elem == null) {
              this.log('No "Salesforce recommendation" carousel found');
              return;
            } else {
              page = '-SF';
            }
          }
        } else {
          let dataTemplate = document.querySelector('body').getAttribute('data-template');
          if (typeof dataTemplate !== 'undefined' && dataTemplate !== null) {
            page = '-' + dataTemplate;
          }
          servingConfigId = document.getElementById("servingConfigId");
          if (typeof servingConfigId !== 'undefined' && servingConfigId !== null && servingConfigId !== '' && servingConfigId.value !== '') {
            googleModel = '_' + servingConfigId.value;
          }
        }
        let elemName = elem.getAttribute('data-name');
        let products = this.getTrackingPayloadData(elem.children, true);
        if (products.length === 0 || typeof products === 'undefined') {
          this.warn("no products found in " + elemName + " carousel");
          return;
        }
        let carouselName;
        if (typeof similarProducts !== 'undefined' && similarProducts !== null && similarProducts.value) {
          carouselName = elemName + '-SOLR';
        } else {
          carouselName = elemName + page + googleModel;
        }
        this.log("tracking '" + elemName + "' carousel with " + products.length + " products");
        window.listCarouselImpression(carouselName, products);
      }
    } catch (e) {
      this.warn('carousel impression tracking not available');
    }
  }

  trackAction(action, data, targetElement) {
    if (this.actions[action]) {
      this.log('tracking action caught: ' + action + " - with params: " + JSON.stringify(data));
      this.actions[action](data, targetElement);
    } else {
      this.warn('no tracking manager found for action ' + action);
    }
  }

  bindEvents() {

    this.$on('click.tracking', ({event}) => {
      if (!$(event.currentTarget).data('disabled') && $(event.currentTarget).data('trackingAction')) {
        const data = $(event.currentTarget).data();
        const action = data.trackingAction;
        this.trackAction(action, data, event.target);
      }

    }, 'body', this.SELECTORS.dataTracking);

    if (this.isLogged()) {
      this.trackAction('login');
    }
  }

  bindCustomEvents() {
    $('body').on('track',  (e, action, params) => {
      const data = [].slice.call(arguments).splice(2);
      this.trackAction(action, data);
    });

    // tracking loadMore button
    this.$on(this.$customEvents.TRACKING.loadMore, e => {
      this.log(
        'emitting tacking event: ' + this.$customEvents.TRACKING.loadMore
      );
      this.actions['loadMore'](e.payload);
  });
  }

  initialeTracking() {
    const ctx = this;
    const $formisimo = $('formisimo');
    window.Tealium = {};

    if ($formisimo.length > 0) {
      $formisimo.each(function () {
        const $this = $(this);
        const data = [{'formId': $this.data('formId'), 'result': $this.data('formResult')}];
        ctx.trackAction('formisimo', data);
      });
    }
  }

  render() {
    this.initialeTracking();
    this.bindEvents();
    this.bindCustomEvents();
    window.addEventListener('load', (event) => {
      this.isLookOnload();
    });
  }
}
